// Choice sets for the Club Radar (P3). The club radar is a pure watchlist with a
// per-entry STATUS the whole club sees (R7). The design placeholders show three
// status chips (stW/stR/stX); the binding decision (R7, API-CONTRACT) is FOUR:
// watching · recommended · rejected · shortlisted — so we ship four segments and
// four filter chips, a documented deviation from the 3-chip placeholder.
//
// Positions + the label palette are REUSED from the agent radar
// (constants/agentRadarChoices.js) via import elsewhere — no fork.

// Status enum (R7). key = the value the backend stores / the API filter param.
// Each carries the design-system hue for its pill (tint bg + strong same-hue
// text, per the design system) and the segment/dot colour.
export const CLUB_STATUS_ORDER = ["watching", "recommended", "rejected", "shortlisted"];

export const CLUB_STATUS_META = {
  watching: {
    key: "watching",
    label: "Watching",
    dot: "#64748B",
    text: "#475467",
    bg: "#F1F5F9",
    border: "#E2E8F0",
  },
  recommended: {
    key: "recommended",
    label: "Recommended",
    dot: "#16A34A",
    text: "#15803D",
    bg: "#ECFDF5",
    border: "#BBF7D0",
  },
  rejected: {
    key: "rejected",
    label: "Rejected",
    dot: "#DC2626",
    text: "#B91C1C",
    bg: "#FEE2E2",
    border: "#FECACA",
  },
  shortlisted: {
    key: "shortlisted",
    label: "Shortlisted",
    dot: "#2283FF",
    text: "#1B6FE0",
    bg: "#E8F1FF",
    border: "#BFDBFE",
  },
};

// Safe lookup — unknown/absent status falls back to Watching (the baseline).
export const clubStatusMeta = (key) => CLUB_STATUS_META[key] || CLUB_STATUS_META.watching;

// Filter chips above the entries table (frame 1a/1b): All · Watching ·
// Recommended · Rejected · Shortlisted · From scout requests. `count` is filled
// at render time from the live entries. `from_scout_requests` is a distinct
// origin filter (R2), not a status.
export const CLUB_STATUS_FILTERS = [
  { value: "all", label: "All" },
  ...CLUB_STATUS_ORDER.map((k) => ({ value: k, label: CLUB_STATUS_META[k].label })),
];

export const FROM_SCOUT_REQUESTS_FILTER = { value: "scout_requests", label: "From scout requests" };

// Sort options — values are the ones clubRadarService sends as `?sort=`.
export const CLUB_SORT_OPTIONS = [
  { value: "recent", label: "Recently added" },
  { value: "status", label: "Status" },
  { value: "name", label: "Name A–Z" },
];

// Sharing tiers (R4). key = share_tier value on the API.
export const CLUB_SHARE_TIERS = [
  { key: "personal", label: "Personal", blurb: "Only you can see this list" },
  {
    key: "selected",
    label: "Selected people",
    blurb: "Choose colleagues who can see and work on this list",
  },
  { key: "club", label: "Whole club", blurb: "Everyone at your club can see and work on this list" },
];
